const VERSION = process.env.REACT_APP_VERSION ?? 'unknown';

function isProduction(): boolean {
  return (
    process.env.NODE_ENV === 'production' && process.env.REACT_APP_DEPLOY_ENV !== 'development'
  );
}

export const Environment = {
  VERSION,
  isProduction,
};
